import { Routes } from '@/routes';

export default {
	'discount.new': () => import('@/modules/discounts/form'),
	'discount.edit': () => import('@/modules/discounts/form'),
} as Routes;
